import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    产品: [
      { label: '功能介绍', to: '/categories?cat=cat-features' },
      { label: '模板库', to: '/categories?cat=cat-features' },
      { label: '更新日志', to: '/categories?cat=cat-updates' },
      { label: '定价方案', to: '#' },
    ],
    资源: [
      { label: '入门指南', to: '/categories?cat=cat-getting-started' },
      { label: '使用教程', to: '/categories?cat=cat-tutorials' },
      { label: '创作技巧', to: '/categories?cat=cat-tips' },
      { label: '案例分享', to: '/categories?cat=cat-cases' },
    ],
    关于: [
      { label: '品牌故事', to: '/about' },
      { label: '联系我们', to: '/about' },
      { label: '加入我们', to: '#' },
      { label: '隐私政策', to: '#' },
    ],
  };

  return (
    <footer className="bg-background-900 text-background-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-2xl font-heading font-bold text-background-50 whitespace-nowrap">
              luluca
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              让创作更简单，让灵感更自由。
            </p>
          </div>
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 luluca. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-400 hover:text-background-200 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-200 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-200 transition-colors" aria-label="GitHub">
              <i className="ri-github-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-200 transition-colors" aria-label="Bilibili">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}